export default __webpack_public_path__ + "static/media/BankTransfer.f74161ac.png";